import React, { Component } from 'react';
import { connect } from 'react-redux'

import { translate } from "react-translate";

//IMPORT SEMANTIC COMPONENTS
import 'semantic-ui-css/semantic.min.css';
import {
    Button,
    Container,
    Segment,
    Menu,
    Image,
    Dropdown,
    Header,
    List,
    Grid,
    Search,
    Advertisement,
    Icon,
    Divider,
    Table,
    Input,
    Item,
} from 'semantic-ui-react';
import './addList.css';

import { modalCreateList } from '../../../redux/actions/ListAction'
import { addList } from '../../../redux/actions/ListAction'
import ModalTooMuchLists from './ModalTooMuchLists';

import API from '../../../services/api';


const mapStateToProps = state => ({
    app: state.app,
    list: state.list
})

const mapActionToProps = {
    modalCreateList: modalCreateList,
    addList: addList
}


class ConnectedAddList extends Component {
    constructor(props) {
        super(props);

        this.state = {
            name: '',
            isModalTooMuchListsOpen: false,
        }

        this.handleChangeName = this.handleChangeName.bind(this);
        this.handleSubmitCreate = this.handleSubmitCreate.bind(this);
        this.closeModalCreateList = this.closeModalCreateList.bind(this);
        this.closeModalTooMuchListsOpen = this.closeModalTooMuchListsOpen.bind(this);
    }

    closeModalTooMuchListsOpen() {
        this.setState({
            isModalTooMuchListsOpen: false,
        })
    }

    handleSubmitCreate(event) {
        var name;
        var self = this;
        event.preventDefault();
        if (this.state.name === null || this.state.name === '') {
            name = 'sans nom';
        } else {
            name = this.state.name;
        }

        var listData = {
            fkuiduser : this.props.app.id,
            name: name
        }
        API.createList(this.props.app.token, listData).then((res) => {
            var response = res.data;
            self.setState({
                response: response
            });
            if (response.msg === 'b_unlimitedlists') {
                self.setState({
                    isModalTooMuchListsOpen: true,
                })
            } else {
                self.addList()
            }
            
        }, (rej) => {
            self.setState({
                error: rej.error
            })
        });
    }

    addList() {
        var self = this;
        var listData = {
            fkuiduser: this.props.app.id
        }
        API.getList(this.props.app.token, listData).then((res) => {
            var response = res.data;
            self.props.addList(response.lists);
            self.closeModalCreateList();
        })
    }

    handleChangeName(event) {
        this.setState({
            name: event.target.value
        });
    }

    closeModalCreateList() {
        this.props.modalCreateList(false);
        if (this.props.close) {
            this.props.close()
        }
    }

    render() {
        const { t } = this.props
        return (
            <div>
                <Grid>
                    <Grid.Row style={{paddingBottom:'0', paddingTop:'40px'}}>
                        <Grid.Column style={{color: 'rgb(114, 114, 114)', fontSize: '1.7em'}}>
                            {t("title3")}
                        </Grid.Column>
                    </Grid.Row>
                    <Grid.Row style={{paddingBottom:'30px'}}>
                        <Grid.Column width={16}>
                            <Input size='huge' fluid onChange={this.handleChangeName} id="inputAddList" />
                        </Grid.Column>
                    </Grid.Row>
                    <Grid.Row columns={2}>
                        <Grid.Column width={8}>
                            <Button
                            id="cancelBtn"
                            size='massive'
                            fluid
                            onClick={this.closeModalCreateList} >{t("title1")}
                            </Button>
                        </Grid.Column>
                        <Grid.Column width={8}>
                            <Button size='massive'
                            id="validBtn"
                            fluid
                            onClick={this.handleSubmitCreate}>{t("title2")}
                            </Button>
                        </Grid.Column>
                    </Grid.Row>
                </Grid>
                <ModalTooMuchLists
                    isOpen={this.state.isModalTooMuchListsOpen}
                    close={this.closeModalTooMuchListsOpen}
                />
            </div>
        )
    }
}
const AddList = connect(mapStateToProps, mapActionToProps)(ConnectedAddList);
export default translate("AddList")(AddList);



// WEBPACK FOOTER //
// ./src/components/Protected/Listes/AddList.js